import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { InfozonebuttonComponent } from './infozonebutton/infozonebutton.component';
import { VideobuttonComponent } from './videobutton/videobutton.component';
import { InfozonemodalComponent } from './infozonemodal/infozonemodal.component';
import { VideomodalComponent } from './videomodal/videomodal.component';
import { QuestionnaireoutputmodalComponent } from './questionnaireoutputmodal/questionnaireoutputmodal.component';
import { BlockquestionnaireComponent } from './blockquestionnaire/blockquestionnaire.component';
import { NumericquestionnaireComponent } from './numericquestionnaire/numericquestionnaire.component';
import { GenericquestionnaireComponent } from './genericquestionnaire/genericquestionnaire.component';
import { QuestionGroupComponent } from './question-group/question-group.component';
import { HomealertComponent } from './homealert/homealert.component';
import { DesktopnavComponent } from './desktopnav/desktopnav.component';
import { MessagebubbleComponent } from './messagebubble/messagebubble.component';
import { RouterModule } from '@angular/router';
import { ExercisebuttonComponent } from './exercisebutton/exercisebutton.component';
import { ExerciseitemComponent } from './exerciseitem/exerciseitem.component';
import { ExercisemodalComponent } from './exercisemodal/exercisemodal.component';
import { SmblocktitleComponent } from './smblocktitle/smblocktitle.component';
import { SmblockimageComponent } from './smblockimage/smblockimage.component';
import { SmblockinfozoneComponent } from './smblockinfozone/smblockinfozone.component';
import { SmblockvideoComponent } from './smblockvideo/smblockvideo.component';
import { SmblocktextComponent } from './smblocktext/smblocktext.component';
import { SmblocktileitemComponent } from './smblocktileitem/smblocktileitem.component';
import { SmblocklistitemComponent } from './smblocklistitem/smblocklistitem.component';
import { SmblockslideitemComponent } from './smblockslideitem/smblockslideitem.component';
import { SmblockbuttonComponent } from './smblockbutton/smblockbutton.component';
import { GroupedquestionnaireComponent } from './groupedquestionnaire/groupedquestionnaire.component';
import { SmblockquestionnaireComponent } from './smblockquestionnaire/smblockquestionnaire.component';
import { SmblockexerciseComponent } from './smblockexercise/smblockexercise.component';
import { SmblockmonitorrecoveryComponent } from './smblockmonitorrecovery/smblockmonitorrecovery.component';
import { SmblockbooktreatmentComponent} from './smblockbooktreatment/smblockbooktreatment.component';
import { DomSanitizer } from '@angular/platform-browser'
import { PipeTransform, Pipe } from "@angular/core";
import { PasswordStrengthComponent } from './password-strength/password-strength.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TimepickermodalComponent } from './timepickermodal/timepickermodal.component';
import { MqaModalComponent } from './mqa-modal/mqa-modal.component';
import { BulletsComponent } from '../bullets/bullets.component';
import { VideoitemComponent } from './videoitem/videoitem.component';
import { AlertModalComponent } from './alert-modal/alert-modal/alert-modal.component';
import { HelpHeaderComponent } from './help-header/help-header.component';
import { SentinelScrollDownComponent } from './sentinel-scroll-down/sentinel-scroll-down.component';
import { SmblockscheckerComponent } from './smblockschecker/smblockschecker.component';
import { TtsLanguageDrawerComponent } from './tts-language-drawer/tts-language-drawer.component';
import { InfoTooltipDirective } from '../directives/info-tooltip.directive';
import { NoContentinfoDirective } from '../directives/no-contentinfo.directive';
import { RovingTabindexDirective } from '../directives/roving-tabindex.directive';
import { VideoInstructionsComponent } from './video-instructions/video-instructions.component';
import { TranslateModule } from '@ngx-translate/core';
import { SymptomCheckerPopupComponent } from './symptom-checker-popup/symptom-checker-popup.component';
import { PipesModule } from '../pipes/pipes.module';
import { SkeletonConditionCardComponent } from './skeleton/skeleton-condition-card/skeleton-condition-card.component';
// import { FadeAnimationDirective } from '../directives/fade-animation.directive';
// import { SlideAnimationDirective } from '../directives/slide-animation.directive';
// import { TouchFeedbackDirective } from '../directives/touch-feedback.directive';


export const GUB_FORMAT = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(public sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@NgModule({
  declarations: [
    InfozonebuttonComponent, 
    VideobuttonComponent, 
    InfozonemodalComponent,
    VideomodalComponent, 
    BlockquestionnaireComponent,
    NumericquestionnaireComponent,
    GenericquestionnaireComponent,
    QuestionGroupComponent,
    HomealertComponent,
    QuestionnaireoutputmodalComponent,
    DesktopnavComponent,
    MessagebubbleComponent,
    ExercisebuttonComponent,
    ExercisemodalComponent,
    ExerciseitemComponent,
    SafeHtmlPipe,
    SmblocktitleComponent,
    SmblockimageComponent,
    SmblockinfozoneComponent,
    SmblockvideoComponent,
    SmblocktextComponent,
    SmblocktileitemComponent,
    SmblocklistitemComponent,
    SmblockslideitemComponent,
    SmblockbuttonComponent,
    GroupedquestionnaireComponent,
    SmblockquestionnaireComponent,
    SmblockexerciseComponent,
    SmblockmonitorrecoveryComponent,
    SmblockbooktreatmentComponent,
    PasswordStrengthComponent,
    TimepickermodalComponent,
    MqaModalComponent,
    BulletsComponent,
    VideoitemComponent,
    HelpHeaderComponent,
    SentinelScrollDownComponent,
    SmblockscheckerComponent,
    TtsLanguageDrawerComponent,
    VideoInstructionsComponent,
    SkeletonConditionCardComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    AlertModalComponent,
    InfoTooltipDirective,
    NoContentinfoDirective,
    RovingTabindexDirective,
    SymptomCheckerPopupComponent,
    TranslateModule,
    PipesModule,
    // FadeAnimationDirective,
    // SlideAnimationDirective,
    // TouchFeedbackDirective
  ],
  exports: [
    SmblocktitleComponent,
    SmblockimageComponent,
    SmblockinfozoneComponent,
    SmblockvideoComponent,
    SmblocktextComponent,
    SmblocktileitemComponent,
    SmblocklistitemComponent,
    SmblockslideitemComponent,
    SmblockbuttonComponent,
    SmblockquestionnaireComponent,
    SmblockexerciseComponent,
    SmblockmonitorrecoveryComponent,
    SmblockbooktreatmentComponent,
    InfozonebuttonComponent, 
    VideobuttonComponent, 
    BlockquestionnaireComponent,
    NumericquestionnaireComponent,
    GenericquestionnaireComponent,
    QuestionGroupComponent,
    HomealertComponent,
    DesktopnavComponent,
    MessagebubbleComponent, 
    ExercisebuttonComponent, 
    ExercisemodalComponent, 
    ExerciseitemComponent, 
    GroupedquestionnaireComponent, 
    PasswordStrengthComponent, 
    MqaModalComponent, 
    BulletsComponent,
    VideoitemComponent,
    AlertModalComponent,
    HelpHeaderComponent,
    NoContentinfoDirective,
    RovingTabindexDirective,
    SymptomCheckerPopupComponent,
    SentinelScrollDownComponent,
    SmblockscheckerComponent,
    TtsLanguageDrawerComponent,
    VideoInstructionsComponent,
    SkeletonConditionCardComponent,
    PipesModule,
    TranslateModule,
    // FadeAnimationDirective,
    // SlideAnimationDirective,
    // TouchFeedbackDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule { }
